import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc, serverTimestamp, orderBy, query, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { Users, Building2, Search as SearchIcon, Plus, X, Loader2 } from 'lucide-react';

export default function Musteriler({ onMusteriSelect }) {
  const navigate = useNavigate();
  const [musteriler, setMusteriler] = useState([]);
  const [arama, setArama] = useState('');
  const [formAcik, setFormAcik] = useState(false);
  const [form, setForm] = useState({
    isimSoyisim: '', email: '', telefon: '', adres: '', isTanimi: '', notlar: ''
  });
  const [musteriYukleniyor, setMusteriYukleniyor] = useState(false);
  const [yukleniyor, setYukleniyor] = useState(true);

  useEffect(() => {
    setYukleniyor(true);
    const q = query(collection(db, 'musteriler'), orderBy('olusturmaTarihi', 'desc'));
    const unsub = onSnapshot(q, snap => {
      setMusteriler(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setYukleniyor(false);
    }, (error) => {
      console.error('Müşteriler yüklenirken hata:', error);
      setYukleniyor(false);
    });
    return unsub;
  }, []);

  const filtreliMusteriler = musteriler.filter(m =>
    m.isimSoyisim?.toLowerCase().includes(arama.toLowerCase()) ||
    m.isTanimi?.toLowerCase().includes(arama.toLowerCase())
  );

  const musteriEkle = async (e) => {
    e.preventDefault();
    if (!form.isimSoyisim.trim()) return;
    setMusteriYukleniyor(true);
    try {
      await addDoc(collection(db, 'musteriler'), {
        ...form, ilerleme: 0, olusturmaTarihi: serverTimestamp(), guncellenmeTarihi: serverTimestamp()
      });
      setForm({ isimSoyisim: '', email: '', telefon: '', adres: '', isTanimi: '', notlar: '' });
      setFormAcik(false);
    } catch (err) {
      alert('Müşteri eklenemedi: ' + err.message);
    } finally {
      setMusteriYukleniyor(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-6">
          <Users size={32} className="text-stone-400" />
          <h1 className="text-2xl font-bold text-white">Müşteriler</h1>
        </div>
        <button onClick={() => setFormAcik(true)} className="w-full max-w-md mx-auto flex items-center justify-center gap-2 bg-gradient-to-r from-emerald-500 to-emerald-600 text-white text-lg font-semibold py-4 px-6 rounded-xl hover:from-emerald-600 hover:to-emerald-700 transition-all shadow-xl mb-8">
          <Plus size={20} /> Yeni Müşteri Ekle
        </button>
        <div className="relative mb-6">
          <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-500" size={18} />
          <input value={arama} onChange={(e) => setArama(e.target.value)} placeholder="Müşteri ara (isim, iş tanımı)..." className="w-full pl-12 pr-4 py-3 bg-stone-900 border border-stone-700 text-white text-lg rounded-2xl focus:outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 placeholder-stone-500 transition-all" />
        </div>
        {filtreliMusteriler.length === 0 ? (
          yukleniyor ? (
            <div className="text-center py-20 bg-stone-900 border border-stone-800 rounded-2xl">
              <Loader2 size={64} className="mx-auto mb-6 text-stone-600 animate-spin" />
              <h3 className="text-xl font-semibold text-white mb-2">Müşteriler Yükleniyor</h3>
              <p className="text-stone-500">Lütfen bekleyin...</p>
            </div>
          ) : (
            <div className="text-center py-20 bg-stone-900 border border-stone-800 rounded-2xl">
              <Building2 size={64} className="mx-auto mb-6 text-stone-600" />
              <h3 className="text-xl font-semibold text-white mb-2">Henüz müşteri yok</h3>
              <p className="text-stone-500 mb-6">İlk müşterinizi ekleyin</p>
              <button onClick={() => setFormAcik(true)} className="bg-white text-stone-900 font-semibold px-8 py-3 rounded-xl hover:bg-stone-200 transition-all shadow-lg">
                Yeni Müşteri Ekle
              </button>
            </div>
          )
        ) : (
          <div className="space-y-3">
            {filtreliMusteriler.slice(0, 12).map((m) => (
                <button key={m.id} onClick={() => onMusteriSelect?.(m.id)} className="w-full flex items-center gap-4 p-5 bg-stone-900 border border-stone-800 rounded-2xl hover:bg-stone-800 hover:shadow-xl transition-all group">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-stone-700 to-stone-600 flex items-center justify-center flex-shrink-0 text-lg font-bold text-stone-200 shadow-lg group-hover:scale-105 transition-transform">
                  {m.isimSoyisim?.charAt(0).toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-lg font-semibold text-white truncate group-hover:text-emerald-400 transition-colors">{m.isimSoyisim}</div>
                  <div className="text-stone-400 text-sm truncate">{m.isTanimi || 'İş tanımı yok'}</div>
                </div>
                <div className="text-right">
                  <div className="text-2xl font-bold text-emerald-400">{m.ilerleme || 0}%</div>
                  <div className="text-xs text-stone-500 uppercase tracking-wider">Tamamlandı</div>
                </div>
              </button>
            ))}
            {filtreliMusteriler.length > 12 && !arama && (
              <div className="text-center py-8 text-stone-500 bg-stone-900 border border-stone-800 rounded-2xl">
                +{filtreliMusteriler.length - 12} müşteri daha var
              </div>
            )}
          </div>
        )}
      </div>

      {/* Add Form Modal */}
      {formAcik && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-6">
          <div className="bg-stone-900 border border-stone-800 rounded-2xl w-full max-w-lg p-1">
            <div className="bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-xl p-1 mb-6">
              <div className="bg-stone-900 rounded-xl p-6">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-bold text-white">Yeni Müşteri</h2>
                  <button onClick={() => setFormAcik(false)} className="text-stone-400 hover:text-white p-2 -m-2 rounded-xl hover:bg-stone-800/50 transition-all">
                    <X size={24} />
                  </button>
                </div>
                <form onSubmit={musteriEkle} className="space-y-4">
                  {[
                    { label: 'İsim Soyisim *', key: 'isimSoyisim', type: 'text', required: true },
                    { label: 'Telefon', key: 'telefon', type: 'tel', required: false },
                    { label: 'E-posta', key: 'email', type: 'email', required: false },
                    { label: 'Adres', key: 'adres', type: 'text', required: false },
                    { label: 'İş Tanımı', key: 'isTanimi', type: 'text', required: false }
                  ].map(({ label, key, type, required }) => (
                    <div key={key}>
                      <label className="block text-sm font-semibold text-stone-300 mb-2">{label}</label>
                      <input type={type} required={required} value={form[key]} onChange={(e) => setForm((f) => ({ ...f, [key]: e.target.value }))} className="w-full bg-stone-800 border border-stone-700 text-white px-4 py-3 rounded-xl text-lg focus:outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 placeholder-stone-500 transition-all" />
                    </div>
                  ))}
                  <div>
                    <label className="block text-sm font-semibold text-stone-300 mb-2">Notlar</label>
                    <textarea rows={3} value={form.notlar} onChange={(e) => setForm((f) => ({ ...f, notlar: e.target.value }))} className="w-full bg-stone-800 border border-stone-700 text-white px-4 py-3 rounded-xl text-lg focus:outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 placeholder-stone-500 resize-vertical transition-all" />
                  </div>
                  <div className="flex gap-3 pt-4">
                    <button type="button" onClick={() => setFormAcik(false)} className="flex-1 bg-stone-800 text-stone-300 py-4 rounded-xl text-lg font-semibold hover:bg-stone-700 transition-all">
                      İptal
                    </button>
                    <button type="submit" disabled={musteriYukleniyor} className="flex-1 bg-gradient-to-r from-emerald-500 to-emerald-600 text-white py-4 rounded-xl text-lg font-semibold hover:from-emerald-600 hover:to-emerald-700 transition-all shadow-xl disabled:opacity-50">
                      {musteriYukleniyor ? 'Ekleniyor...' : 'Müşteri Ekle'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

